import { Action } from '@ngrx/store';
import { ResetPasswordUser } from 'src/app/shared/models/reset-password-user';
import { IAuthTable } from '../auth.interfaces';



export enum ApproverAuthActionTypes {
    APPROVER_LOGIN = '[ApproverAuth] Approver Login',
    APPROVER_LOGIN_SUCCESS = '[ApproverAuth] Approver Login Success',
    APPROVER_LOGIN_SUCCESS_REDIRECT = '[ApproverAuth] Approver Login Success Redirect',
    APPROVER_LOGIN_FAILURE = '[ApproverAuth] Approver Login Failure',
    APPROVER_REFRESH_TOKEN = '[ApproverAuth] Approver Refresh Token',
    APPROVER_REFRESH_TOKEN_SUCCESS = '[ApproverAuth] Approver Refresh Token Success',
    APPROVER_REFRESH_TOKEN_FAILURE = '[ApproverAuth] Approver Refresh Token Failure',
    APPROVER_LOGOUT = '[ApproverAuth] Approver Logout',
    APPROVER_DISPLAY_ERROR = '[ApproverAuth] Approver Display Error',
    APPROVER_FORGOT_PASSWORD = '[ApproverAuth] Approver Forgot Password',
    APPROVER_FORGOT_PASSWORD_COMPLETE = '[ApproverAuth] Approver Forgot Password Complete',
    APPROVER_FORGOT_PASSWORD_ERROR = '[ApproverAuth] Approver Forgot Password Error',
    APPROVER_CHECK_LOGIN_FAILURE = '[ApproverAuth] Approver Check Login Failure',
    APPROVER_RESET_PASSWORD = '[ApproverAuth] Approver Reset Password',
    APPROVER_RESET_PASSWORD_COMPLETE = '[ApproverAuth] Approver Reset Password Complete',
    APPROVER_CHECK_LOGIN = '[ApproverAuth] Check Login',
}


export class ApproverLogin implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_LOGIN;
    constructor(public payload: { userName: string; password: string }) { }
}

export class ApproverLoginSuccess implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_LOGIN_SUCCESS;
    constructor(public payload: IAuthTable) { }
}

export class ApproverLoginFailure implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_LOGIN_FAILURE;
    constructor(public payload: string) { }
}
export class ApproverLoginSuccessRedirect implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_LOGIN_SUCCESS_REDIRECT;
}

export class ApproverRefreshToken implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_REFRESH_TOKEN;
}

export class ApproverRefreshTokenSuccess implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_REFRESH_TOKEN_SUCCESS;
    constructor(public payload: IAuthTable) { }
}

export class ApproverRefreshTokenFailure implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_REFRESH_TOKEN_FAILURE;
    constructor(public payload: string) { }
}

export class ApproverDisplayError implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_DISPLAY_ERROR;
    constructor(public payload: string) { }
}

export class ApproverLogout implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_LOGOUT;
}


export class ApproverForgotPassword implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_FORGOT_PASSWORD;
    constructor(public payload: string) { }
}

export class ApproverForgotPasswordComplete implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_FORGOT_PASSWORD_COMPLETE;
}

export class ApproverForgotPasswordError implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_FORGOT_PASSWORD_ERROR;
    constructor(public payload: string) { }
}

export class ApproverCheckLogin implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_CHECK_LOGIN;
}

export class ApproverCheckLoginFailure implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_CHECK_LOGIN_FAILURE;
}

export class ApproverResetPasswordComplete implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_RESET_PASSWORD_COMPLETE;
}

export class ApproverResetPassword implements Action {
    readonly type = ApproverAuthActionTypes.APPROVER_RESET_PASSWORD;
    constructor(public payload: ResetPasswordUser) { }
}


export type ApproverAuthActions = ApproverLogin
    | ApproverLoginSuccess
    | ApproverLoginFailure
    | ApproverLoginSuccessRedirect
    | ApproverRefreshToken
    | ApproverRefreshTokenSuccess
    | ApproverRefreshTokenFailure
    | ApproverDisplayError
    | ApproverLogout
    | ApproverForgotPassword
    | ApproverForgotPasswordComplete
    | ApproverForgotPasswordError
    | ApproverCheckLogin
    | ApproverCheckLoginFailure
    | ApproverResetPasswordComplete
    | ApproverResetPassword;
